import { Field, Fieldset, Label } from "@headlessui/react";
import logo from "../assets/logo.png";
import { Button } from "./tailwind/button";
import { Input } from "./tailwind/input";
import { Text } from "./tailwind/text";
import { Link } from "react-router-dom";
import { useState } from "react";
import { Gradient } from "./Gradient";
import { api } from "../api";

export const ForgotPasswordPage = ({
  setShowSignUp,
  handleForgotPassword,
  isLoading,
}) => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({ email: "", password: "" });

  const validate = () => {
    const newErrors = { email: "", password: "" };
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email address is invalid";
    }
    setErrors(newErrors);
    return !newErrors.email;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(errors);
    if (validate()) {
      api.user.sendResetPassword({ email: email.toLowerCase().trim() });
    }
  };

  return (
    <Gradient>
      <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img className="mx-auto h-10 w-auto" src={logo} alt="Simio" />
          <h2 className="mt-6 text-center text-2xl font-bold font-title leading-9 tracking-tight text-gray-900">
            Reset your password
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px] z-20">
          <div className="bg-white px-6 py-5 shadow sm:rounded-lg sm:px-12">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <Fieldset>
                <Field>
                  <Label>Email address</Label>
                  <Input
                    name="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    {...(errors.email && { "data-invalid": true })}
                  />
                  {errors.email && (
                    <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                  )}
                </Field>
              </Fieldset>

              <Button
                type="submit"
                color="primaryButton"
                className="flex w-full justify-center bg-yellow font-title font-bold leading-6 "
              >
                Receive a new password by email
              </Button>
            </form>
          </div>

          <Text className="mt-10 text-center">
            Not a member?{" "}
            <Link
              onClick={() => setShowSignUp(true)}
              className="font-semibold text-purple hover:text-purple/80"
            >
              Sign up instead
            </Link>
          </Text>
        </div>
      </div>
    </Gradient>
  );
};
